import React from 'react';
import { Redirect } from 'react-router-dom';
import { LOGIN } from '../constants/routes';

const Home = () => {
  return <Redirect to={LOGIN} />;
};

export default Home;
